"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppMessage = void 0;
const useTranslation_1 = require("./useTranslation");
const appContext_1 = require("../appContext");
const DEFAULT_MESSAGES = {
    requiredFormField: '',
};
function useAppMessage(id) {
    const { messages } = (0, appContext_1.useAppContext)();
    const { t } = (0, useTranslation_1.useTranslation)();
    const messageId = messages[id];
    return messageId ? t(messageId) : DEFAULT_MESSAGES[id];
}
exports.useAppMessage = useAppMessage;
